import { Component, EventEmitter, Input, OnInit, Output, OnChanges } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ForgotPasswordService } from './forgot.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: 'forgot-password.component.html',
    styleUrls:['./forgot-password.component.css']
})

export class ForgotPasswordComponent implements OnInit {
    emailAddress:any='';
    emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";  
    isSuccess:boolean=false;
    isValidFormSubmitted = false;  
    @Output() onLoginNav: EventEmitter<any> = new EventEmitter <any> ();
    constructor(private forgot:ForgotPasswordService) { }

    ngOnInit() { }

    onFormSubmit(form: NgForm) {  
        this.isValidFormSubmitted = false;  
        if (form.invalid) {  
           return;  
        }  
        if(this.emailAddress.length > 1){
            this.forgot.generatePassword(this.emailAddress).subscribe((response:any)=>{
                // document.getElementById('login-register-modal-close-btn').click();
                // this.onLoginNav.emit(false);
    
             this.isSuccess = true;
             setTimeout(()=>{                           
                this.isSuccess = false;
            }, 4000);
            })
            this.isValidFormSubmitted = true;  
            form.resetForm();  
        }
       
     }  
    

    showLoginPage(){
        this.onLoginNav.emit(false);
    }


    
}